module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--clock-a3debeacbe6ac5a39de84631fd2dfeef.svg";